import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { connectMediaStore, useMMSelector, useMMDispatchActions } from './withOwnReduxStore';
import { setCurrentSubfolderId, unsetCurrentSubfolderId } from '../actions';
import { getCurrentSubfolderId, getCurrentSubfolder } from '../selectors';
export const useCurrentSubfolder = ()=>_object_spread({}, useMMSelector((state)=>({
            currentSubfolderId: getCurrentSubfolderId(state),
            currentSubfolder: getCurrentSubfolder(state)
        })), useMMDispatchActions({
        setCurrentSubfolderId,
        unsetCurrentSubfolderId
    }));
export default connectMediaStore((state)=>({
        currentSubfolderId: getCurrentSubfolderId(state),
        currentSubfolder: getCurrentSubfolder(state)
    }), {
    setCurrentSubfolderId,
    unsetCurrentSubfolderId
});

//# sourceMappingURL=withCurrentSubfolder.js.map